import './App.css';
import S1_Header from "./pages/MainPage/S1_Header";
import S2_TransactionDeatils from "./pages/MainPage/S2_TransactionDeatils";
import S3_About from "./pages/MainPage/S3_About";
import S4_Ecosystem from "./pages/MainPage/S4_Ecosystem";
import S5_Roadmap from "./pages/MainPage/S5_Roadmap";
import S6_Tokenomics from "./pages/MainPage/S6_Tokenomics";
import S7_Community from "./pages/MainPage/S7_Community";
import S8_Faqs from "./pages/MainPage/S8_Faqs";
import S9_Footer from "./pages/MainPage/S9_Footer";

function App() {
  return (
    <div>
      <S1_Header />
      <S2_TransactionDeatils />
      <S3_About />
      <S4_Ecosystem />
      <S5_Roadmap />
      <S6_Tokenomics />
      <S7_Community />
      <S8_Faqs />
      <S9_Footer />
    </div>
  );
}

export default App;
